import { Globe, Check, Loader2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { LANGUAGES, DEFAULT_LANG } from "@/i18n/languages";
import { useI18n } from "@/i18n/I18nProvider";

export function LanguageSelector({ dark }) {
  const { lang, setLang, t, busy } = useI18n();
  const cur = LANGUAGES.find((l) => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="language-selector" aria-label={`${t("Language")}: ${cur.native}`}
          className={`gap-1.5 ${dark ? "border-slate-700 bg-slate-900 text-slate-100 hover:bg-slate-800" : ""} ${lang !== DEFAULT_LANG ? "border-blue-300 text-blue-700" : ""}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" data-testid="translation-busy" /> : <Globe className="h-4 w-4" />}
          <span className="hidden sm:inline">{t("Language")}:</span>
          <span data-no-translate data-testid="current-language">{cur.native}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-[70vh] w-60 overflow-y-auto" data-no-translate>
        <DropdownMenuLabel className="text-xs text-slate-500">{t("Language")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onSelect={() => setLang(l.code)} data-testid={`lang-option-${l.code}`} lang={l.code}
            className={`flex justify-between ${l.code === lang ? "bg-blue-50 font-semibold text-blue-700" : ""}`} aria-current={l.code === lang}>
            <span>{l.native}{l.code !== DEFAULT_LANG && <span className="ml-1.5 text-xs text-slate-500">— {l.english}</span>}</span>
            {l.code === lang && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
        {lang !== DEFAULT_LANG && (<>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={() => setLang(DEFAULT_LANG)} data-testid="lang-reset-english" className="text-xs text-slate-600">Switch back to English</DropdownMenuItem>
          <p className="px-2 py-1.5 text-[11px] leading-snug text-slate-500">AI-assisted translation. The English source text is authoritative.</p>
        </>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
